import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ApiError } from '@/utils/types';
import { fetchSoftTagList } from '../api/fetch-soft-tags.api';
import type {
  TagMappingRequest,
  TagMappingUpdateRequest,
} from '../utils/match-maker.types';
import {
  postTagMapping,
  deleteTagMapping,
  patchTagMapping,
} from '../api/tag-mapping.api';

export type FetchMaterialSoftTagParams = {
  tagNames?: string;
};

export const getTimeSeriesSoftTags = createAsyncThunk(
  'MatchMaker/getTimeSeriesSoftTags',
  async (params: FetchMaterialSoftTagParams | undefined, thunkAPI) => {
    try {
      // Call API to get material match summary
      return await fetchSoftTagList({ tag_names: params?.tagNames });
    } catch (e: unknown) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to fetch soft tags'
      );
    }
  }
);

export const createTagMapping = createAsyncThunk(
  'MatchMaker/createTagMapping',
  async (payload: TagMappingRequest, thunkAPI) => {
    try {
      return await postTagMapping(payload);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to create tag mapping'
      );
    }
  }
);

export const removeTagMapping = createAsyncThunk(
  'MatchMaker/removeTagMapping',
  async (tagMappingId: string, thunkAPI) => {
    try {
      await deleteTagMapping(tagMappingId);
      return tagMappingId;
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to delete tag mapping'
      );
    }
  }
);

export const updateTagMapping = createAsyncThunk(
  'MatchMaker/updateTagMapping',
  async (
    {
      tagMappingId,
      payload,
    }: { tagMappingId: string; payload: TagMappingUpdateRequest },
    thunkAPI
  ) => {
    try {
      return await patchTagMapping(tagMappingId, payload);
    } catch (e: unknown) {
      return thunkAPI.rejectWithValue(
        (e as ApiError).message || 'Failed to update tag mapping'
      );
    }
  }
);
